module.exports = __webpack_public_path__ + "static/media/hospitalLogo.f2ac93f2.png";